import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { QaCheckField } from '@app/shared/models';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-qa-check-element',
  templateUrl: './qa-check-element.component.html',
  styleUrls: ['./qa-check-element.component.scss']
})
export class QaCheckElementComponent implements OnInit, OnChanges {
  @Input() public parentForm: UntypedFormGroup;
  @Input() public field: QaCheckField;
  @Input() public disabled = false;

  public isCollapsed = true;
  public readonly INPUT_STYLE = { width: '8em', textAlign: 'end' };
  public unit: string;

  public ngOnInit(): void {
    this.disableControls();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentForm'] && !changes['parentForm'].firstChange) {
      const newForm: UntypedFormGroup = changes['parentForm'].currentValue;
      this.parentForm = newForm;
      this.disableControls();
    }

    if (changes['isReadOnly'] && !changes['isReadOnly'].firstChange) {
      const newIsReadOnly: boolean = changes['isReadOnly'].currentValue;
      this.disabled = newIsReadOnly;
      this.disableControls();
    }
  }

  public toggleContent(): void {
    this.isCollapsed = !this.isCollapsed;
  }
  public isMeasurementUnitVisible(): boolean {
    return !this.field.isLineClearanceCheck && !!this.field.measurementResultUnitId && this.field.measurementResultUnitId.length > 0;
  }

  private disableControls(): void {
    this.disableMeasurementControl();
    this.disableCommentControl();
  }

  private disableMeasurementControl(): void {
    if (this.disabled) {
      this.parentForm.get('measurementResult')?.disable({ emitEvent: false });
    } else {
      this.parentForm.get('measurementResult')?.enable({ emitEvent: false });
    }
  }

  private disableCommentControl(): void {
    if (this.disabled) {
      this.parentForm.get('comment')?.disable({ emitEvent: false });
    } else {
      this.parentForm.get('comment')?.enable({ emitEvent: false });
    }
  }
}
